import { getIpdConfig } from '../../store/localstorage';

type ObjectType = { [key: string]: string };

export const INSURANCE_TYPE: ObjectType = {
    individual: 'Individual',
    family: 'Family',
    critical_illness: 'Critical Illness',
    disability_insurance: 'Disability Insurance',
};

export const DEPARTMENT: ObjectType = {
    general_medicine: 'General Medicine',
    surgery: 'Surgery',
    orthopedics: 'Orthopedics',
    cardiology: 'Cardiology',
    neurology: 'Neurology',
    ob_gyn: 'Obstetrics and Gynecology (OB/GYN)',
    pediatrics: 'Pediatrics',
    oncology: 'Oncology',
    nephology: 'Nephology',
};

export const ADMISSION_CATEGORY: ObjectType =
    getIpdConfig()?.categories?.reduce((acc, category) => {
        acc[category.id] = category.name;
        return acc;
    }, {} as ObjectType) || {};

console.log('ADMISSION_CATEGORY', ADMISSION_CATEGORY);

export const ADMIT_PATIENT_CONTAINER_ID = 'admit-patient';
